import * as Redux from 'redux';
import logger from 'redux-logger';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import rootReducer from './root-reducer';

const { applyMiddleware, compose, legacy_createStore } = Redux;

const reduxCompat = Redux as typeof Redux & {
  createStore?: typeof legacy_createStore;
};

if (!reduxCompat.createStore) {
  reduxCompat.createStore = legacy_createStore;
}

const middlewares: Redux.Middleware[] = [thunk as Redux.Middleware];

export let store;
if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);

  const composeEnhancers =
    (
      window as Window & {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
      }
    ).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  store = legacy_createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)));
} else {
  store = legacy_createStore(rootReducer, applyMiddleware(...middlewares));
}

export const persist = persistStore(store);

export default { store };
